/**
 * Newsletter Form Optimization
 * Debounces input validation and defers submission
 * Improves INP on form interactions
 */

class NewsletterFormOptimizer {
  constructor() {
    this.debounceTimer = null;
    this.debounceDelay = 300;
  }

  /**
   * Initialize form optimization
   */
  init() {
    this.optimizeNewsletterForm();
    console.log('✅ Newsletter form optimization initialized');
  }

  /**
   * Optimize newsletter form
   */
  optimizeNewsletterForm() {
    // Find newsletter forms
    const forms = document.querySelectorAll('[data-newsletter-form], form[action*="newsletter"], form[action*="contact"]');
    
    forms.forEach((form) => {
      const input = form.querySelector('input[type="email"]');
      if (input) {
        // Add debounced validation
        input.addEventListener('input', (e) => {
          this.debounceValidation(e.target, form);
        }, { passive: true });

        // Optimize form submission
        form.addEventListener('submit', (e) => {
          this.optimizeSubmission(e, form);
        });
      }
    });
  }

  /**
   * Debounce validation to reduce INP
   */
  debounceValidation(input, form) {
    clearTimeout(this.debounceTimer);
    
    this.debounceTimer = setTimeout(() => {
      this.validateEmail(input, form);
    }, this.debounceDelay);
  }

  /**
   * Validate email asynchronously
   */
  validateEmail(input, form) {
    const email = input.value.trim();
    
    // Use requestIdleCallback for validation
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => {
        this.performValidation(email, input, form);
      });
    } else {
      this.performValidation(email, input, form);
    }
  }

  /**
   * Perform actual validation
   */
  performValidation(email, input, form) {
    const isValid = this.isValidEmail(email);
    
    if (isValid) {
      input.classList.remove('error');
      input.classList.add('valid');
      form.classList.remove('form-error');
    } else if (email.length > 0) {
      input.classList.add('error');
      input.classList.remove('valid');
      form.classList.add('form-error');
    }
  }

  /**
   * Simple email validation
   */
  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  /**
   * Optimize form submission
   */
  optimizeSubmission(e, form) {
    // Defer heavy operations to next frame
    requestAnimationFrame(() => {
      // Allow form submission to proceed
      // The browser will handle the actual submission
    });
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    const optimizer = new NewsletterFormOptimizer();
    optimizer.init();
  });
} else {
  const optimizer = new NewsletterFormOptimizer();
  optimizer.init();
}
